module.exports = __webpack_public_path__ + "media/bootstrap-icons/instagram-7a3b5420.svg";